import { createRoot } from 'react-dom/client';
import React from 'react';
import TaxCalculator from './react/TaxCalculator';

const getItemsFromScript = async ($script) => {
  if (!$script) {
    return [];
  }

  const json = await JSON.parse($script.textContent);

  if (!json || json.length === 0) {
    console.error('No data found in tax-calculator__data');
    return [];
  }

  return json;
};

const initTaxCalculator = async ($el) => {
  const $wrap = document.createElement('div');
  $wrap.classList.add('tax-calculator__wrap');
  $el.appendChild($wrap);
  const $script = $el.querySelector('.tax-calculator__data');
  const data = (await getItemsFromScript($script)) || [];
  const root = createRoot($wrap);
  root.render(<TaxCalculator {...data} />);
  $script?.remove();
};

document
  .querySelectorAll('.tax-calculator')
  .forEach(($tax) => initTaxCalculator($tax));
